export default {
	setQuiz(state, quiz) {
		state.quiz = quiz;
	},
	chooseAnswer(state, data){
		if ( data[2] == 1){
			state.answer.filter((x) => (x.id == data[0] ? x.data = [data[1]] : '') );
		} else {
			state.answer.filter((x) => (x.id == data[0] && !x.data.includes(data[1]) ? x.data.push(data[1]) : ''));
		}
		function checkCorrect(listAns, answers){
			let flag = true;
			listAns.data.map(function(value) {
				if (!answers.includes(value)){
					flag = false;
					return flag;
				}
				return flag;
			});
			return flag;
		}
		// eslint-disable-next-line array-callback-return
		state.answer.filter(function(x) {
			if(x.id == data[0]){
				x.num += 1;
				const question = state.quiz.questions.filter(x =>x.id==data[0]);
				if(question[0].answers.length == x.num){
					const listAns = state.answer.filter(x => x.id == data[0]);
					const flag = checkCorrect(listAns[0],question[0].answers);
					if (flag){
						x.correct = 1;
					} else {
						x.correct = 0;
					}
				}
			}
		});
		const get_num_answer = state.answer.filter((x)=> (x.id == data[0] ? x : ''));
		const get_num_correct = state.quiz.questions.filter((q) => (q.id == data[0] ? q : '') );
		if (get_num_answer[0].num == get_num_correct[0].answers.length){
			state.finish += 1;
		}
		if (state.finish == state.quiz.questions.length) {
			state.quiz.playComplate();
		}
	},
	sendAnswer(state,data){
		function checkTypeAnswer(question, data){
			let info = {
				isFlag: false,
				option_id: null
			};
			question.options.map(function(q){
				const valAnswer = q.text.toLowerCase().normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '');
				const typeAnswer = data.value.toLowerCase().normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '');
				
				if(valAnswer.trim().replace(/\s+/g,' ') == typeAnswer.trim().replace(/\s+/g,' ')){
					info = {
						isFlag: true,
						option_id: q.id
					};
					return info;
				}
				return info;
			});
			return info;
		}
		// eslint-disable-next-line array-callback-return
		state.answer.filter(function(x){
			if(x.id == data.question_id){
				x.data = data.value;
				x.num += 1;
				const get_ques = state.quiz.questions.filter(
					(x) =>x.id==data.question_id
				);
				const info = checkTypeAnswer(get_ques[0], data);
				if (info.isFlag){
					if (get_ques[0].answers.includes(info.option_id)){
						state.answer.filter((ans) => (ans.id == data.question_id ? ans.correct = 1 : ''));
					} else{
						state.answer.filter((ans) => (ans.id == data.question_id ? ans.correct = 0 : ''));
					}
				}
				else{
					state.answer.filter((ans) => (ans.id == data.question_id ? ans.correct = 0 : ''));
				}
			}
		});
		state.finish += 1;
		if (state.finish == state.quiz.questions.length) {
			state.quiz.playComplate();
		}
	},
	reQuiz(state){
		state.answer = [];
		state.finish = 0;
		state.trackingPlay = false;
	},
};
